import React from "react";
import {
  db,
  firebase,
  storage,
  sendDynamicEmail,
  sendSMS,
} from "firebase/fbConfig.js";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import moment from "moment"
import DatePicker from 'react-date-picker';

import axios from 'axios'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Icon from "@material-ui/core/Icon";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/profileFormStyle.jsx";

import { addNewShipper } from "store/actions/profileActions.jsx"

// Assets
import precincts from "variables/precincts.jsx"

class Form extends React.Component {

  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      ...this.state,
      allGroups: [],
      physicalAddress: "",
      physicalCity: "",
      physicalState: "",
      physicalZip: "",
      mailingAddress: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: ""
    };
  }

  handleDOBChange = (dob) => {
    console.log(dob._d)
    if (dob) {
      this.setState(() => ({ dob: dob._d }))
    }
  }

  handlePickUpDateChange = (ksmsAddedDate) => {
    console.log(ksmsAddedDate)
    if (ksmsAddedDate) {
      this.setState(() => ({ ksmsAddedDate: ksmsAddedDate, ksmsAddedDateAPI: moment(ksmsAddedDate).format('YYYY-MM-DD') }))
    } else {
      this.setState(() => ({ ksmsAddedDate: false }))
    }
  }

  handleKSMSDateChange = date => {
    this.setState({
      startDate: date
    });
  };

  componentDidMount() {
    db.collection('haney-groups').get()
      .then(snapshot => {
        const allGroups = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        this.setState({ allGroups });
      })
  }

  // componentDidMount = () => {
  //   var inputElement = document.getElementById('mainPhone');
  //   inputElement.removeEventListener('keydown', this.enforceFormat);
  //   inputElement.removeEventListener('keyup', this.formatToPhone);
  //   var inputElement2 = document.getElementById('mainPhone');
  //   inputElement2.removeEventListener('keydown', this.enforceFormat);
  //   inputElement2.removeEventListener('keyup', this.formatToPhone);

  // }

  // componentWillUnmount = () => {
  //   var inputElement = document.getElementById('mainPhone');
  //   inputElement.removeEventListener('keydown', this.enforceFormat);
  //   inputElement.removeEventListener('keyup', this.formatToPhone);
  //   var inputElement2 = document.getElementById('mainPhone');
  //   inputElement2.removeEventListener('keydown', this.enforceFormat);
  //   inputElement2.removeEventListener('keyup', this.formatToPhone);

  // }

  //Phone number code modified from
  // https://stackoverflow.com/questions/30058927/format-a-phone-number-as-a-user-types-using-pure-javascript 
  isNumericInput = (event) => {
    const key = event.keyCode;
    return ((key >= 48 && key <= 57) || // Allow number line
      (key >= 96 && key <= 105) // Allow number pad
    );
  };

  isModifierKey = (event) => {
    const key = event.keyCode;
    return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
      (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
      (key > 36 && key < 41) || // Allow left, up, right, down
      (
        // Allow Ctrl/Command + A,C,V,X,Z
        (event.ctrlKey === true || event.metaKey === true) &&
        (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
      )
  };

  enforceFormat = (event) => {
    // Input must be of a valid number format or a modifier key, and not longer than ten digits
    if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
      event.preventDefault();
    }
  };

  formatToPhone = (event) => {
    if (this.isModifierKey(event)) {
      return;
    }

    // I am lazy and don't like to type things more than once
    const target = event.target;
    const input = event.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only    
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    let targetValue
    if (input.length > 6) { targetValue = `(${zip}) ${middle} - ${last}`; }
    else if (input.length > 3) { targetValue = `(${zip}) ${middle}`; }
    else if (input.length > 0) { targetValue = `(${zip}`; }
    target.value = targetValue
    this.setState({
      phone: targetValue
    })
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  onChange = dob => this.setState({ dob })

  handleChange = (e) => {
    let value = e.target.value
    if (e.target.id === "firstName" || e.target.id === "lastName") {
      value = value.charAt(0).toUpperCase() + value.slice(1)
    }
    console.log(value)
    this.setState({
      [e.target.id]: value
    })
  }

  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { allGroups, group, ...newState } = this.state;
    for (let key in newState) {
      if (typeof newState[key] === 'string') newState[key] = newState[key].trim();
    }

    db.collection('haney-shippers').add({
      ...newState,
      ksms: newState.ksmsID ? ((newState.ksmsAddedDate) ? true : false) : false,
      updatedAt: new Date()
    })
      .then(async docRef => {

        if (group) {
          const { description, ...groupObj } = allGroups.find(g => g.id === group);
          await Promise.all([
            db.collection('haney-groups').doc(group).collection('haney-shippers').doc(docRef.id).set({
              id: docRef.id,
              name: newState.name
            }),
            db.collection('haney-shippers').doc(docRef.id).collection('haney-groups').doc(group ? group : "bpn6FBAqZiV3e8mMNWJd").set(groupObj)
          ]);
        };

        window.location.reload();

      })
    // addNewShipper(newState);
  }

  handleToggle(value) {
    this.setState({
      [value]: !this.state[value],
      mailingAddress: (this.state.mailingAddress ? "" : this.state.physicalAddress),
      mailingCity: (this.state.mailingCity ? "" : this.state.physicalCity),
      mailingState: (this.state.mailingState ? "" : this.state.physicalState),
      mailingZip: (this.state.mailingZip ? "" : this.state.physicalZip)
    });
  }
  handleToggleKSMS(value) {
    this.setState({
      [value]: !this.state[value],
    });
  }


  handleToggleTerms(value) {
    const { termGroups } = this.state;
    const currentIndex = termGroups.indexOf(value);
    const newTermGroups = [...termGroups];

    if (currentIndex === -1) {
      newTermGroups.push(value);
    } else {
      newTermGroups.splice(currentIndex, 1);
    }

    this.setState({
      termGroups: newTermGroups
    });
  }

  render() {
    const { classes } = this.props;

    const userTypes = ['', 'Shipper', 'Carrier', 'User']

    console.log(this.state)
    return (
      <div className={classes.formContainer}>
        {/* <form onSubmit={this.handleSubmit} */}
        <form onSubmit={this.handleSubmit}
        ><h2 className={classes.modalTitle}>ADD NEW SHIPPER</h2>
          <GridContainer justify="center">
            <GridItem xs={11}>
              {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error</h5> : null}
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Business Name"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Physical Address"
                    id="physicalAddress"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="City"
                    id="physicalCity"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={6} sm={3}>
                  <CustomInput
                    labelText="State"
                    id="physicalState"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={6} sm={3}>
                  <CustomInput
                    labelText="Zip"
                    id="physicalZip"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Main Phone"
                    id="mainPhone"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Main Email"
                    id="businessEmail"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Business Opens"
                    id="businessOpen"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Business Closes"
                    id="businessClose"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Location Notes"
                    id="locationNotes"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Remit to Parent Connection"
                    id="remit"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="group"
                      // className={classes.selectLabel}
                      style={{ color: "black" }}
                    >
                      Group:
                    </InputLabel>
                    {console.log("point1", this.props)}
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{

                        select: classes.selectMenu,
                      }}
                      value={this.state.group}
                      onChange={this.handleSelectChange}
                      inputProps={{
                        id: "group",
                        name: "group",
                      }}
                    >
                      {this.state.allGroups.map(
                        (group, i) => (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                            value={group.id}
                            key={group.id}
                            style={{ color: "black !important" }}
                          >
                            {group.name}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </GridItem>

                {/*<GridItem xs={12} sm={6}>
                    <Datetime
                      selected={this.state.dob}
                      onChange={this.handleDOBChange}
                      timeFormat={true}
                      isValidDate={this.valid}
                      renderInput={(dateInputProps, open, close) => (
                        <CustomInput
                          inputProps={{ ...dateInputProps, id: 'dob', name: 'dob', required: false, 
                          defaultValue: this.props.user.title ? this.props.user.title : ''
                        }}
                          onBlur={close}
                          onFocus={open}
                          labelText="Date of Birth"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      )}
                    />
                        </GridItem>*/}



                <h3>Accounting / Regulatory</h3>
                <br />

                <div className={classes.checkboxAndRadio}>
                  Mailing address is Physical Address?
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleToggle("mailingIsPhysical")}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="Enabled"
                  />
                </div>
                <GridItem xs={12} sm={6}>
                  {this.state.mailingIsPhysical ?
                    <CustomInput
                      labelText="Mailing Address"
                      id="mailingAddress"
                      formControlProps={{
                        fullWidth: true
                      }}
                      labelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.physicalAddress ? this.state.physicalAddress : ''
                      }}
                    />
                    :
                    <CustomInput
                      labelText="Mailing Address"
                      id="mailingAddress"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.mailingAddress ? this.state.mailingAddress : ''
                      }}
                    />
                  }
                </GridItem>
                <GridItem xs={12} sm={6}>

                  {this.state.mailingIsPhysical ?
                    <CustomInput
                      labelText="City"
                      id="mailingCity"
                      formControlProps={{
                        fullWidth: true
                      }}
                      labelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.physicalCity ? this.state.physicalCity : ''
                      }}
                    />
                    :
                    <CustomInput
                      labelText="City"
                      id="mailingCity"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.mailingCity ? this.state.mailingCity : ''
                      }}
                    />
                  }
                </GridItem>
                <GridItem xs={6} sm={3}>

                  {this.state.mailingIsPhysical ?
                    <CustomInput
                      labelText="State"
                      id="mailingState"
                      formControlProps={{
                        fullWidth: true
                      }}
                      labelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.physicalState ? this.state.physicalState : ''
                      }}
                    />
                    :
                    <CustomInput
                      labelText="State"
                      id="mailingState"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.mailingState ? this.state.mailingState : ''
                      }}
                    />
                  }
                </GridItem>
                <GridItem xs={6} sm={3}>
                  {this.state.mailingIsPhysical ?
                    <CustomInput
                      labelText="Zip"
                      id="mailingZip"
                      formControlProps={{
                        fullWidth: true
                      }}
                      labelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.physicalZip ? this.state.physicalZip : ''
                      }}
                    />
                    :
                    <CustomInput
                      labelText="Zip"
                      id="mailingZip"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (event) => this.handleChange(event),
                        value: this.state.mailingZip ? this.state.mailingZip : ''
                      }}
                    />
                  }

                </GridItem>

                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Accounting Email"
                    id="accountingEmail"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Quickbooks ID"
                    id="quickbooksID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Accounting Notes"
                    id="accountingNotes"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Credit Card Interface"
                    id="creditCardInterface"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Credit Approval"
                    id="creditApproval"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Credit Terms"
                    id="creditTerms"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Credit Limit"
                    id="creditLimit"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="AR Balance"
                    id="arBalance"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Accounting Notes"
                    id="accountingNotes"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="DSO"
                    id="dso"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="KSMS ID"
                    id="ksmsID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>


                <GridItem xs={12} sm={6}>
                  KSMS Added Date:
                      <DatePicker
                    onChange={this.handlePickUpDateChange}
                    value={this.state.ksmsAddedDate ? this.state.ksmsAddedDate : ''}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Master Service Agreement"
                    id="msa"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                    }}
                  />
                </GridItem>
                {/*<GridItem xs={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}>
                      <InputLabel
                        htmlFor="county"
                        className={classes.selectLabel}>
                        County:
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.county}
                        onChange={this.handleSelectChange}
                        inputProps={{
                          id: 'county',
                          name: 'county'
                        }}
                      >
                        {
                          counties.map((item) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem
                              }}
                              value={item}
                              key={item}
                            >{item}</MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                      </GridItem>*/}


              </GridContainer>
              {/*<FormControl
                      fullWidth
                      className={classes.selectFormControl}>
                      <InputLabel
                        htmlFor="userType"
                        className={classes.selectLabel}>
                        User Type:
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.userType}
                        onChange={this.handleSelectChange}
                        inputProps={{
                          id: 'userType',
                          name: 'userType'
                        }}
                      >
                        {
                          userTypes.map((item) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem
                              }}
                              value={item}
                              key={item}
                            >{item}</MenuItem>
                          ))
                        }
                      </Select>
                      </FormControl>*/}

              <h5 className={classes.bodyText}>APPROVAL CHECKS</h5>
              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <br />
                <Button
                  color="primary"
                  onClick={() => window.open('https://www.experian.com/', "_blank")}
                >CREDIT CHECK</Button><br />
              </div>
              <Button
                color="primary"
                onClick={() => window.open('https://sso.tsa.dhs.gov/oam/server/obrareq.cgi?encquery%3DTZbSZV5Au1u3Qj7WoEnSKF0T6TVz%2FfkI5bFW48P0ZnfqI3i3Q2ISWjPJjLceSHvS%2F9zFDqlZ%2BJKAyInLZBLv4MusdeMJDsag5OyIxc4urFP6Au6r5zvcJ%2FHpc2fGNYpo1Lp%2FXuleXp7xhM0VMbGt2evX4IzhBuJSuagtBaJBo0TZWoqoCgFRCFv%2Fv3IeSWfs3cfF3PxumC0SsRetlAadnVqaZA67U9GrlEEIOea3qmI1bR6xw4ouf49%2BM%2B4nghNZ9RQ%2Bge2bZZCT9vxbyPgCpIObvDuwYDNN8vvQil4x%2B1b72B7z9NtHSmwhrViDWaq%2Fbm7JiFQ8bE5CAap3hTEUfTZJTdaRMiWBfQPnQKzFu5I%3D%20agentid%3Dr115prd1_tsaapps.tsa.dhs.gov_443%20ver%3D1%20crmethod%3D2&ECID-Context=1.0006qqsPsH61BhgLHEG7yf0000bl0008zX%3BkXjE', "_blank")}
              >KSMS</Button><br /><br />

              <br />

            </GridItem>
          </GridContainer>
          <Button
            type="submit"
            color="primary"
            style={{
              marginLeft: "10px",
              marginBottom: "10px"
            }}
          >
            Save Changes
            </Button>
        </form>
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/addNewShipperProfileForm.jsx